import {FC, ReactNode} from 'react'
import {Container} from 'react-bootstrap'

interface PageContainerProps {
  children: ReactNode;
  fluid?: boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  className?: string;
  padding?: string;
}

const PageContainer: FC<PageContainerProps> = ({
  children,
  fluid = 'xl',
  className = '',
  padding = 'pt-2 pt-md-4'
}) => {
  return (
    <Container
      fluid={fluid}
      className={`${padding} ${className}`}
    >
      {children}
    </Container>
  )
}

export default PageContainer
